import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LegalTabs from './LegalTabs';
import {
  resolveLegalDocumentLocale,
  TERMS_SECTIONS_EN,
  type LegalDocumentLocale,
  type LegalTextSection,
} from './legalContent';
import { TERMS_SECTIONS_AR, TERMS_SECTIONS_ID, TERMS_SECTIONS_MN } from './termsTranslations';

const TERMS_SECTIONS: LegalTextSection[] = [
  {
    title: '제1조 (목적)',
    paragraphs: [
      '이 약관은 주식회사 뉴베이스(이하 "회사")가 운영하는 메디크루 웹사이트, 모바일 애플리케이션, VR 기반 의료 시뮬레이션, 교육 콘텐츠, 클래스·커리큘럼 관리, 실습 결과 관리, 주문·결제 및 관련 부가서비스(이하 "서비스")의 이용 조건과 절차, 회사와 회원의 권리·의무 및 책임사항을 정함을 목적으로 합니다.',
    ],
  },
  {
    title: '제2조 (정의)',
    items: [
      '"회원"이란 이 약관에 동의하고 회사가 정한 절차에 따라 계정을 생성하거나 기관을 통해 초대되어 서비스를 이용하는 자를 말합니다.',
      '"기관회원"이란 병원, 학교, 교육기관, 기업 등 서비스 이용 계약 또는 주문을 통해 소속 구성원에게 서비스를 제공하는 법인 또는 단체를 말합니다.',
      '"관리자" 또는 "마스터"란 기관회원의 위임을 받아 소속 회원, 클래스, 라이선스, 콘텐츠, 실습 결과 등을 관리하는 권한을 가진 회원을 말합니다.',
      '"학습자"란 클래스 참여, 시뮬레이션 실습, 콘텐츠 열람, 실습 결과 확인 등 교육 목적의 기능을 이용하는 회원을 말합니다.',
      '"콘텐츠"란 회사가 제공하거나 서비스 내에서 이용 가능한 VR·모바일 시뮬레이션, 시나리오, 이미지, 영상, 음성, 문항, 평가 기준, 문서, 데이터 및 기타 디지털 자료를 말합니다.',
      '"유료서비스"란 구독, 라이선스, 오픈클래스, 기관 클래스, 장비 또는 부가서비스 등 회사가 대가를 받고 제공하는 서비스를 말합니다.',
    ],
  },
  {
    title: '제3조 (약관의 게시와 개정)',
    items: [
      '회사는 회원이 쉽게 확인할 수 있도록 이 약관을 서비스 화면 또는 연결 화면에 게시합니다.',
      '회사는 관련 법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있습니다.',
      '회사가 약관을 개정하는 경우 적용일자와 주요 개정 사유를 적용일 7일 전부터 공지합니다. 회원에게 불리하거나 중대한 변경은 30일 전부터 공지하거나 전자우편, 서비스 알림 등 합리적인 방법으로 안내합니다.',
      '회원이 개정 약관의 적용일 이후에도 서비스를 계속 이용하는 경우 개정 약관에 동의한 것으로 봅니다. 회원이 개정 약관에 동의하지 않는 경우 서비스 이용계약을 해지할 수 있습니다.',
    ],
  },
  {
    title: '제4조 (회원가입 및 계정)',
    items: [
      '회원가입은 이용자가 회사가 정한 정보를 제공하고 약관 및 필수 정책에 동의한 뒤 회사가 이를 승낙함으로써 완료됩니다.',
      '회사는 허위 정보 제공, 타인 명의 사용, 기존 이용 제한 이력, 서비스 운영상 또는 기술상 지장이 있는 경우 가입을 거절하거나 사후에 이용계약을 해지할 수 있습니다.',
      '회원은 계정 정보가 정확하게 유지되도록 관리해야 하며, 계정 및 비밀번호 관리 책임은 회원에게 있습니다.',
      '기관회원이 초대하거나 생성한 계정의 권한, 소속, 이용 범위는 기관회원의 계약 및 관리 정책에 따라 달라질 수 있습니다.',
    ],
  },
  {
    title: '제5조 (서비스의 제공)',
    items: [
      '회사는 다음 각 호의 서비스를 제공합니다. 1) 의료교육용 VR·모바일 시뮬레이션 콘텐츠 제공 2) 클래스, 커리큘럼, 참여자, 실습 기록 및 평가 결과 관리 3) 기관, 사용자, 라이선스, 장비, 주문 및 결제 관리 4) 시나리오, 자료실, 블로그, 고객문의 등 교육·운영 지원 기능 5) 기타 회사가 정하는 부가서비스',
      '서비스의 세부 기능, 이용 가능 콘텐츠, 제공 방식, 지원 기기 및 권한은 회원 유형, 기관 계약, 주문 상품, 라이선스 상태에 따라 달라질 수 있습니다.',
      '회사는 서비스 품질 개선, 보안, 정책 변경, 계약 범위 변경 또는 운영상 필요에 따라 서비스의 전부 또는 일부를 변경할 수 있습니다.',
    ],
  },
  {
    title: '제6조 (유료서비스, 주문 및 결제)',
    items: [
      '유료서비스의 가격, 이용 기간, 제공 범위, 결제수단, 세금계산서 또는 영수증 발행 조건은 주문 화면, 견적서, 계약서 또는 별도 안내에 따릅니다.',
      '회원 또는 기관회원은 결제 전에 상품명, 이용 기간, 수량, 금액, 환불 조건 등 주문 내용을 확인해야 합니다.',
      '결제가 완료되면 회사는 해당 주문 또는 계약 조건에 따라 라이선스, 클래스, 콘텐츠 또는 장비 이용 권한을 부여합니다.',
      '결제 오류, 승인 실패, 주문 정보 불일치가 발생한 경우 회사는 주문을 보류하거나 취소할 수 있습니다.',
    ],
  },
  {
    title: '제7조 (청약철회, 취소 및 환불)',
    items: [
      '디지털 콘텐츠 또는 온라인 서비스는 제공이 개시되었거나 회원의 이용으로 콘텐츠 열람, 다운로드, 실습 참여, 라이선스 활성화 등 사용이 시작된 경우 관련 법령에서 허용하는 범위 내에서 청약철회 또는 환불이 제한될 수 있습니다.',
      '유료 클래스 또는 오픈클래스의 취소·환불은 각 상품 상세, 주문 화면, 계약서 또는 별도 환불 정책에 따릅니다.',
      '회사의 귀책사유로 서비스가 정상 제공되지 않은 경우 회사는 재제공, 기간 연장, 환불 등 합리적인 조치를 취합니다.',
      '환불 시 결제수단, 결제대행사, 금융기관의 처리 정책에 따라 실제 환불 완료까지 시간이 소요될 수 있습니다.',
    ],
  },
  {
    title: '제8조 (회원의 의무)',
    paragraphs: ['회원은 다음 각 호의 행위를 해서는 안 됩니다.'],
    items: [
      '타인의 계정, 개인정보 또는 결제수단을 무단으로 사용하는 행위',
      '허위 정보 등록, 권한 없는 기관 또는 클래스 접근, 초대 링크의 부정 사용',
      '콘텐츠를 무단 복제, 배포, 전송, 판매, 대여, 공유하거나 서비스 밖에서 활용하는 행위',
      '서비스의 보안, 인증, 과금, 권한 관리 또는 정상 운영을 방해하는 행위',
      '실습 결과, 평가 데이터, 주문 정보 등을 위조·변조하거나 부정한 방법으로 생성하는 행위',
      '관련 법령, 이 약관, 회사의 안내 또는 기관회원의 이용 정책을 위반하는 행위',
    ],
  },
  {
    title: '제9조 (기관회원 및 관리자 책임)',
    items: [
      '기관회원과 관리자는 소속 회원의 권한 부여, 초대, 탈퇴, 클래스 배정, 라이선스 사용 및 개인정보 취급이 관련 법령과 내부 정책에 맞게 이루어지도록 관리해야 합니다.',
      '기관회원은 소속 회원이 서비스를 교육 목적에 맞게 이용하도록 안내해야 하며, 소속 회원의 이용 행위가 계약 또는 약관을 위반하지 않도록 협조해야 합니다.',
      '기관회원의 계약 종료, 라이선스 만료 또는 관리자의 권한 회수 시 소속 회원의 서비스 이용 범위가 제한될 수 있습니다.',
    ],
  },
  {
    title: '제10조 (콘텐츠 및 지식재산권)',
    items: [
      '서비스와 콘텐츠에 관한 저작권, 상표권, 특허권, 영업비밀 및 기타 지식재산권은 회사 또는 정당한 권리자에게 귀속됩니다.',
      '회원은 서비스 이용 목적 범위 내에서 콘텐츠를 열람하고 사용할 수 있으며, 회사의 사전 서면 동의 없이 콘텐츠를 복제, 수정, 2차적 저작물 작성, 배포, 전송, 판매, 대여, 공개 시연 또는 외부 교육 자료로 사용할 수 없습니다.',
      '회원 또는 기관회원이 서비스에 업로드하거나 입력한 자료에 대한 권리는 원 권리자에게 귀속됩니다. 다만 회사는 서비스 제공, 운영, 보안, 장애 대응, 품질 개선 및 통계 분석을 위해 필요한 범위에서 해당 자료를 이용할 수 있습니다.',
    ],
  },
  {
    title: '제11조 (실습 결과 및 데이터)',
    items: [
      '실습 기록, 평가 결과, 학습 이력 등 서비스 이용 과정에서 생성되는 데이터는 회원의 학습 지원, 기관 운영, 서비스 품질 개선 및 계약 이행을 위해 처리될 수 있습니다.',
      '기관회원은 계약 및 권한 범위 내에서 소속 회원의 실습 결과와 학습 이력을 열람·관리할 수 있습니다.',
      '회사는 개인정보가 포함된 데이터의 처리에 관하여 개인정보처리방침을 따릅니다.',
    ],
  },
  {
    title: '제12조 (서비스의 중단)',
    items: [
      '회사는 설비 점검, 장애 대응, 보안 조치, 서비스 개선, 통신망 또는 클라우드 장애, 천재지변 등 부득이한 사유가 있는 경우 서비스의 전부 또는 일부를 일시 중단할 수 있습니다.',
      '회사는 예정된 점검의 경우 사전에 공지하도록 노력합니다. 다만 긴급 장애, 보안 위협 등 사전 공지가 어려운 경우 사후에 안내할 수 있습니다.',
    ],
  },
  {
    title: '제13조 (이용 제한 및 계약 해지)',
    items: [
      '회원이 이 약관 또는 관련 정책을 위반한 경우 회사는 경고, 일시 정지, 권한 회수, 콘텐츠 접근 제한, 계정 해지 등 필요한 조치를 할 수 있습니다.',
      '회원은 언제든지 서비스 내 기능 또는 고객센터를 통해 탈퇴를 요청할 수 있습니다. 다만 진행 중인 주문, 결제, 정산, 법령상 보관 의무가 있는 정보는 필요한 기간 동안 보관될 수 있습니다.',
      '기관회원 계약에 따라 생성된 계정은 기관회원의 요청 또는 계약 종료에 따라 이용이 제한될 수 있습니다.',
    ],
  },
  {
    title: '제14조 (장비 이용)',
    items: [
      'VR 기기 등 장비 대여 또는 제공이 포함된 상품의 경우 장비의 대여 기간, 배송, 반납, 분실·훼손 책임, 비용 부담은 상품 안내, 계약서 또는 별도 장비 이용정책에 따릅니다.',
      '회원은 장비를 선량한 관리자의 주의로 사용해야 하며, 제3자에게 임의로 양도, 대여, 담보 제공하거나 허가되지 않은 목적으로 사용할 수 없습니다.',
    ],
  },
  {
    title: '제15조 (책임 제한)',
    items: [
      '회사는 천재지변, 통신망 장애, 클라우드 또는 제3자 서비스 장애, 회원의 귀책사유 등 회사의 합리적 통제를 벗어난 사유로 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.',
      '회사는 회원 또는 기관회원이 서비스에 입력한 정보의 정확성, 적법성, 신뢰성에 대해 책임을 지지 않습니다.',
      '서비스는 의료교육과 훈련을 위한 것으로, 실제 환자 진료나 의학적 판단을 대체하지 않습니다.',
    ],
  },
  {
    title: '제16조 (손해배상)',
    paragraphs: [
      '회사 또는 회원이 이 약관을 위반하여 상대방에게 손해를 입힌 경우 귀책 당사자는 관련 법령에 따라 손해를 배상해야 합니다.',
    ],
  },
  {
    title: '제17조 (준거법 및 관할)',
    paragraphs: [
      '이 약관은 대한민국 법령에 따라 해석됩니다. 서비스 이용과 관련하여 분쟁이 발생한 경우 민사소송법 등 관련 법령에서 정한 관할 법원을 관할 법원으로 합니다.',
    ],
  },
  {
    title: '제18조 (문의)',
    paragraphs: [
      '서비스 및 약관에 관한 문의는 아래 연락처로 할 수 있습니다.',
      '회사명: 주식회사 뉴베이스',
      '이메일: contact@newbase.kr',
      '전화: 02-564-8853',
    ],
  },
];

export default function TermsOfService(): React.ReactElement {
  const { i18n } = useTranslation();
  const legalLocale = resolveLegalDocumentLocale(i18n.language);
  const termsSectionsByLocale: Record<LegalDocumentLocale, LegalTextSection[]> = {
    ko: TERMS_SECTIONS,
    en: TERMS_SECTIONS_EN,
    ar: TERMS_SECTIONS_AR,
    id: TERMS_SECTIONS_ID,
    mn: TERMS_SECTIONS_MN,
  };
  const termsHeaderByLocale: Record<LegalDocumentLocale, { title: string; effectiveDate: string }> = {
    ko: { title: '메디크루 서비스 이용약관', effectiveDate: '시행일: 2026.05.06' },
    en: { title: 'Medicrew Terms of Service', effectiveDate: 'Effective date: May 6, 2026' },
    ar: { title: 'شروط خدمة Medicrew', effectiveDate: 'تاريخ النفاذ: 6 مايو 2026' },
    id: { title: 'Ketentuan Layanan Medicrew', effectiveDate: 'Tanggal berlaku: 6 Mei 2026' },
    mn: { title: 'Medicrew үйлчилгээний нөхцөл', effectiveDate: 'Хүчин төгөлдөр болох огноо: 2026.05.06' },
  };
  const termsSections = termsSectionsByLocale[legalLocale];
  const termsHeader = termsHeaderByLocale[legalLocale];

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <article className="mx-auto max-w-[920px]" dir={legalLocale === 'ar' ? 'rtl' : undefined}>
      <LegalTabs activeTab="terms" />

      <header className="pt-8 border-b border-gray-200 pb-8">
        <p className="mt-3 text-4xl font-semibold text-gray-900">
          {termsHeader.title}
        </p>
        <p className="mt-4 text-base text-gray-500">
          {termsHeader.effectiveDate}
        </p>
      </header>

      <div className="mt-16 space-y-10 text-base leading-8 text-gray-700">
        {termsSections.map((section) => (
          <section key={section.title}>
            <h2 className="mb-4 text-xl font-bold text-gray-900">{section.title}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="mb-3">
                {paragraph}
              </p>
            ))}
            {section.items && (
              <ol className="list-decimal space-y-2 pl-5">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            )}
          </section>
        ))}
      </div>
    </article>
  );
}
